/**
 * What to show for a voucher's narration.
 *
 * A reader's last line of defence, not the fix. Vouchers imported before the
 * gateway's text reader was corrected hold the literal five words
 * "[object Object]" — a stringified XML node, written to the column and shown
 * faithfully by every screen that reads it. The parser no longer produces them
 * and a backfill clears the ones already stored, but a row that slips through
 * should read as empty rather than as rubbish someone might take for data.
 *
 * Blank, never "[object Object]": nothing is more honest here than a wrong
 * narration, and a CA reading a day book should not be left wondering whether
 * it meant something.
 */
const BROKEN = '[object Object]';

export function narrationText(v: unknown): string {
  if (typeof v !== 'string') return ''; // an object reaching a screen is the same fault
  const s = v.trim();
  return s === BROKEN ? '' : v;
}
